import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** `/portal/grupa/:groupId/portofolii` — now a tab of the group page
 *  (06.10.2026); the old address keeps working. */
export default function PortalPortfolios() {
  const { groupId } = useParams();
  return <Navigate to={`/portal/grupa/${groupId}?fila=portofolii`} replace />;
}
